import styled from '@emotion/styled'
import { Divider as MuiDivider } from '@mui/material'
import { spacing } from '@mui/system'

export const DaiDivider = styled(MuiDivider)(spacing)

DaiDivider.defaultProps = {
  my: 3,
}
